import { Result } from 'antd';

export const noAuthElement = <Result title="403" subTitle="No auth" />;

export const notFoundElement = <Result title="404" subTitle="not found" />;
